import React, { Context } from "react";

function useContextSafely<T>(context: Context<T | null>, errorMessage?: string): T;

function useContextSafely<T>(context: Context<T | undefined>, errorMessage?: string): T;

function useContextSafely<T>(
    context: Context<T | null | undefined>,
    errorMessage = `${context.displayName} value is not found. Did you forgot to use context Provider?`
): T {
    const value = React.useContext(context);

    if (value === null || value === undefined) {
        throw new Error(errorMessage);
    }

    return value;
}

export default useContextSafely;
